// extracted by mini-css-extract-plugin
module.exports = {"ghost_block":"LoaderStyles_ghost_block__TnkXB","ghost":"LoaderStyles_ghost__31k5n"};